import {changeEvent, dispatchCustomEvent} from "../../../../../../../webpack/modules/events";
import {isDesktop} from "../../../../../../../webpack/modules/devices";
import {updatePriceElements} from "../../../../../../../webpack/modules-optimized/product-list";

changeEvent('#product-list-page .product-configuration-tissue[data-option-type="selectable"] input[name="tissue"]', true, function(element) {
    let mainContainer = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = mainContainer.querySelector('.open-configuration .preview-option-tissue');

    dispatchCustomEvent(
        'productTissueChanged',
        {
            'option': container,
            'previewElement': previewElement,
        }
    );
    container.querySelectorAll('.tissue.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    mainContainer.querySelector('input[name="option-tissue"]').value = element.value;
    updatePriceElements(container);
    container.dataset.completed = 'true';
    dispatchCustomEvent('productListProductConfigurationChanged');
});